import React, { CSSProperties } from 'react';
import Select, { PropsValue } from 'react-select';
import { SelectOption } from '@/assets/data/selectOptions';
import theme from '@/styles/theme';

interface Props {
  useDefault?: boolean;
  options: Array<SelectOption>;
  defaultValue?: PropsValue<SelectOption>;
  onChange: (e: any) => void;
  disabled?: boolean;
  selectStyle?: CSSProperties;
  singleValue?: CSSProperties;
  indicatorStyle?: CSSProperties;
  isSearchable?: boolean;
  value?: any;
  placeholder?: string;
}

const SelectComponent = (props: Props) => {
  const {
    options,
    defaultValue,
    onChange,
    disabled,
    selectStyle,
    singleValue,
    isSearchable,
    value,
    useDefault,
    placeholder,
    indicatorStyle
  } = props;

  return (
    <Select
      value={value}
      isSearchable={isSearchable}
      styles={{
        control: () => ({
          display: 'flex',
          flexFlow: 'row',
          width: '150px',
          padding: '1.9px 0 1.9px 8px',
          border: `1px solid ${theme.DF_COLOR.GRAY100}`,
          background: '#fff',
          borderRadius: '5px',
          height: '42px !important',
          ...selectStyle
        }),
        singleValue: base => ({
          ...base,
          ...singleValue
        }),
        indicatorSeparator: base => ({
          ...base,
          ...indicatorStyle
        })
      }}
      options={options}
      defaultValue={defaultValue}
      onChange={(e: any) => {
        const value = useDefault ? e : e.value;
        onChange(value);
      }}
      isDisabled={disabled}
      isOptionDisabled={option => option.disabled}
      placeholder={placeholder}
    />
  );
};

export default SelectComponent;
